import React from "react";
import s from "./index.module.scss";
import Photo from "components/photo";
import Intro from "components/intro";
import Footer from "components/footer";
import { CSSTransition } from "react-transition-group";
// import classNames from "classnames/bind"
// const cx = classNames.bind(s);

const Main = ({ data, show }) => {
	return (
		<CSSTransition
			in={show}
			timeout={600}
			classNames={{ ...s }}
			unmountOnExit
		>
			<main className={s.main}>
				<Intro />
				{data.map((item, i) => (
					<Photo
						i={i}
						key={i}
						image={item.photo}
						preview={item.preview}
						title={item.title}
						copy={item.copy}
					/>
				))}
				<Footer />
			</main>
		</CSSTransition>
	);
};

export default Main;
